import React from 'react';
import { Menu } from 'semantic-ui-react';

import Link from '../../../atoms/Link';
import DropdownMenu from './DropdownMenuItems';
import { isExternalPage } from '../../../services/pages';

export default ({ links, linksAs }) => {
  return links.map(link => {
    const { links, title, as, pageType, slug, url, contentProps, ...rest } = link;

    if (links) {
      return <DropdownMenu title={title} options={links} linksAs={linksAs} />;
    }

    return (
      <Menu.Item link key={link.title}>
        <Link
          to={isExternalPage(pageType) ? url : slug}
          linkAs={as || linksAs}
          title={title}
          internal={!isExternalPage(pageType)}
          contentProps={contentProps}
          {...rest}
        />
      </Menu.Item>
    );
  });
};
